import { MutationTree } from 'vuex'

import { MultiUserState } from '@/types/store'
import { IUser } from '@/types/user'

export const mutations: MutationTree<MultiUserState> = {
  multiUsersLoadStart(state) {
    state.isMultiUsersLoading = true
  },
  multiUsersLoaded(state, payload: [IUser[], number]) {
    state.multiUsers = payload[0]
    state.total = payload[1]
    state.isMultiUsersLoading = false
  },
  setMultiUser(state, multiUser: IUser) {
    state.multiUser = multiUser
  },
  createMultiUser(state, payload: MultiUserState['multiUser']) {
    state.multiUsers.push(payload)
  },
  updateMultiUser(state, payload: MultiUserState['multiUser']) {
    if (!payload) return
    if (!state.multiUsers) return
    const userIndex = state.multiUsers.findIndex(
      multiUser => multiUser.id === payload.id,
    )
    state.multiUsers.splice(userIndex, 1, payload)
  },
  deleteMultiUser(state, id: number) {
    if (!state.multiUsers) return
    const userIndex = state.multiUsers.findIndex(
      multiUser => multiUser.id === id,
    )
    state.multiUsers.splice(userIndex, 1)
  },
}
